import React from "react";

const FbShareIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="9.066" height="18.134" viewBox="0 0 9.066 18.134"><path d="M19.733,8.733h-2.18c-.7,0-1.22.286-1.22,1.008V11h3.4l-.269,3.4H16.333v9.067h-3.4V14.4H10.667V11h2.266V8.821c0-2.292,1.206-3.488,3.923-3.488h2.877Z" transform="translate(-10.667 -5.333)" fill={props.fill}></path></svg>
    )
}

export default FbShareIcon;
